import { Spinner } from '@kvdbil/components';
import styled from 'styled-components';

const Container = styled.div`
  padding: 4rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

interface Props {
  text?: string;
}

const DefaultSpinner = ({ text }: Props) => {
  return (
    <Container>
      <Spinner />
      {text}
    </Container>
  );
};

export default DefaultSpinner;
